import BaseModel from '../base/BaseModel.model';
import { ReportEvaluationState } from '@/enums/ReportEvaluationState';
import BudgetSubItemEvaluation from './budgetSubItemEvaluation.model';
export default class BudgetItemEvaluation extends BaseModel {

    public proposalBudgetItemExecutionId:number = 0;
    public porposalUserReportEvaluationId:number = 0;
    public state:ReportEvaluationState = ReportEvaluationState.Pendiente;
    public budgetSubItemEvaluations:Array<BudgetSubItemEvaluation> = [];
   
    constructor(){
       super();
       this.init();
    }

    init(){}
}